// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/automations/v1/automations_executions.proto" (package "c1.api.automations.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { TriggerType } from "./automations";
import { AutomationStep } from "./automations";
import { ScheduleTriggerAppUser } from "./automations";
import { FormTrigger } from "./automations";
import { ScheduleTrigger } from "./automations";
import { GrantDeletedTrigger } from "./automations";
import { GrantFoundTrigger } from "./automations";
import { UserCreatedTrigger } from "./automations";
import { UsageBasedRevocationTrigger } from "./automations";
import { AppUserUpdatedTrigger } from "./automations";
import { AppUserCreatedTrigger } from "./automations";
import { UserProfileChangeTrigger } from "./automations";
import { ManualAutomationTrigger } from "./automations";
import { Duration } from "../../../../google/protobuf/duration";
import { AutomationContext } from "./automations";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.automations.v1.TerminateAutomationRequest
 */
export interface TerminateAutomationRequest {
    /**
     * @generated from protobuf field: int64 id = 1
     */
    id: number;
}
/**
 * @generated from protobuf message c1.api.automations.v1.TerminateAutomationResponse
 */
export interface TerminateAutomationResponse {
}
/**
 * @generated from protobuf message c1.api.automations.v1.ListAutomationExecutionsRequest
 */
export interface ListAutomationExecutionsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ListAutomationExecutionsResponse
 */
export interface ListAutomationExecutionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationExecution automation_executions = 1
     */
    automationExecutions: AutomationExecution[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetAutomationExecutionRequest
 */
export interface GetAutomationExecutionRequest {
    /**
     * @generated from protobuf field: int64 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionExpandMask expand_mask = 2
     */
    expandMask?: AutomationExecutionExpandMask;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetAutomationExecutionResponse
 */
export interface GetAutomationExecutionResponse {
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecution automation_execution = 1
     */
    automationExecution?: AutomationExecution;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionView view = 3
     */
    view?: AutomationExecutionView;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecution
 */
export interface AutomationExecution {
    /**
     * @generated from protobuf field: int64 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: string automation_template_id = 2
     */
    automationTemplateId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionState state = 6
     */
    state: AutomationExecutionState;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationContext context = 7
     */
    context?: AutomationContext;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 8
     */
    completedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Duration duration = 9
     */
    duration?: Duration;
    /**
     * @generated from protobuf field: int32 current_version = 10
     */
    currentVersion: number;
    /**
     * @generated from protobuf field: bool is_draft = 11
     */
    isDraft: boolean;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionExpandMask
 */
export interface AutomationExecutionExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionView
 */
export interface AutomationExecutionView {
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecution automation_execution = 1
     */
    automationExecution?: AutomationExecution;
    /**
     * @generated from protobuf field: string automation_path = 2
     */
    automationPath: string;
    /**
     * @generated from protobuf field: string automation_execution_trigger_path = 3
     */
    automationExecutionTriggerPath: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationExecutionsResponse
 */
export interface SearchAutomationExecutionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationExecutionView list = 1
     */
    list: AutomationExecutionView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationExecutionsRequest
 */
export interface SearchAutomationExecutionsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string automation_template_id = 3
     */
    automationTemplateId: string;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionExpandMask expand_mask = 5
     */
    expandMask?: AutomationExecutionExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationExecutionRef refs = 6
     */
    refs: AutomationExecutionRef[];
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationExecutionState execution_step_states = 7
     */
    executionStepStates: AutomationExecutionState[];
    /**
     * @generated from protobuf field: int64 execution_id = 8
     */
    executionId: number;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionTrigger
 */
export interface AutomationExecutionTrigger {
    /**
     * @generated from protobuf field: int64 automation_execution_id = 1
     */
    automationExecutionId: number;
    /**
     * @generated from protobuf field: string actor_id = 2
     */
    actorId: string;
    /**
     * @generated from protobuf oneof: kind
     */
    kind: {
        oneofKind: "manual";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ManualAutomationTrigger manual = 101
         */
        manual: ManualAutomationTrigger;
    } | {
        oneofKind: "userProfileChange";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UserProfileChangeTrigger user_profile_change = 102
         */
        userProfileChange: UserProfileChangeTrigger;
    } | {
        oneofKind: "appUserCreated";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AppUserCreatedTrigger app_user_created = 103
         */
        appUserCreated: AppUserCreatedTrigger;
    } | {
        oneofKind: "appUserUpdated";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AppUserUpdatedTrigger app_user_updated = 104
         */
        appUserUpdated: AppUserUpdatedTrigger;
    } | {
        oneofKind: "usageBasedRevocation";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UsageBasedRevocationTrigger usage_based_revocation = 105
         */
        usageBasedRevocation: UsageBasedRevocationTrigger;
    } | {
        oneofKind: "userCreated";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UserCreatedTrigger user_created = 106
         */
        userCreated: UserCreatedTrigger;
    } | {
        oneofKind: "grantFound";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantFoundTrigger grant_found = 107
         */
        grantFound: GrantFoundTrigger;
    } | {
        oneofKind: "grantDeleted";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantDeletedTrigger grant_deleted = 108
         */
        grantDeleted: GrantDeletedTrigger;
    } | {
        oneofKind: "schedule";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ScheduleTrigger schedule = 109
         */
        schedule: ScheduleTrigger;
    } | {
        oneofKind: "form";
        /**
         * @generated from protobuf field: c1.api.automations.v1.FormTrigger form = 110
         */
        form: FormTrigger;
    } | {
        oneofKind: "scheduleAppUser";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ScheduleTriggerAppUser schedule_app_user = 111
         */
        scheduleAppUser: ScheduleTriggerAppUser;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionStep
 */
export interface AutomationExecutionStep {
    /**
     * @generated from protobuf field: int64 automation_execution_id = 1
     */
    automationExecutionId: number;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionStepState state = 3
     */
    state: AutomationExecutionStepState;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationStep automation_step = 4
     */
    automationStep?: AutomationStep;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationContext context = 5
     */
    context?: AutomationContext;
    /**
     * @generated from protobuf field: string error_message = 6
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionStepOutput output = 7
     */
    output?: AutomationExecutionStepOutput;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionStepOutput
 */
export interface AutomationExecutionStepOutput {
    /**
     * @generated from protobuf field: int64 automation_execution_id = 1
     */
    automationExecutionId: number;
    /**
     * @generated from protobuf field: string automation_execution_step_id = 2
     */
    automationExecutionStepId: string;
    /**
     * @generated from protobuf field: string id = 3
     */
    id: string;
    /**
     * @generated from protobuf oneof: kind
     */
    kind: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionStepOutputSuccess success = 101
         */
        success: AutomationExecutionStepOutputSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionStepOutputError error = 102
         */
        error: AutomationExecutionStepOutputError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionStepOutputSuccess
 */
export interface AutomationExecutionStepOutputSuccess {
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationContext exported_context = 1
     */
    exportedContext?: AutomationContext;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionStepOutputError
 */
export interface AutomationExecutionStepOutputError {
    /**
     * @generated from protobuf field: string error = 1
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.CompletedAutomationExecutionStep
 */
export interface CompletedAutomationExecutionStep {
    /**
     * @generated from protobuf field: int64 automation_execution_id = 1
     */
    automationExecutionId: number;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionStepState state = 3
     */
    state: AutomationExecutionStepState;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionStep step = 4
     */
    step?: AutomationExecutionStep;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetCompletedAutomationExecutionStepRequest
 */
export interface GetCompletedAutomationExecutionStepRequest {
    /**
     * @generated from protobuf field: int64 automation_execution_id = 1
     */
    automationExecutionId: number;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetCompletedAutomationExecutionStepResponse
 */
export interface GetCompletedAutomationExecutionStepResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.CompletedAutomationExecutionStep completed_automation_execution_steps = 1
     */
    completedAutomationExecutionSteps: CompletedAutomationExecutionStep[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.ListAutomationExecutionStepsRequest
 */
export interface ListAutomationExecutionStepsRequest {
    /**
     * @generated from protobuf field: int64 automation_execution_id = 1
     */
    automationExecutionId: number;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ListAutomationExecutionStepsResponse
 */
export interface ListAutomationExecutionStepsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationExecutionStep automation_execution_steps = 1
     */
    automationExecutionSteps: AutomationExecutionStep[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationExecutionStepsRequest
 */
export interface SearchAutomationExecutionStepsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: int64 automation_execution_id = 3
     */
    automationExecutionId: number;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationExecutionStepRef refs = 5
     */
    refs: AutomationExecutionStepRef[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationExecutionStepsResponse
 */
export interface SearchAutomationExecutionStepsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationExecutionStep list = 1
     */
    list: AutomationExecutionStep[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetAutomationExecutionStepOutputRequest
 */
export interface GetAutomationExecutionStepOutputRequest {
    /**
     * @generated from protobuf field: int64 automation_execution_id = 1
     */
    automationExecutionId: number;
    /**
     * @generated from protobuf field: string step_id = 2
     */
    stepId: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetAutomationExecutionStepOutputResponse
 */
export interface GetAutomationExecutionStepOutputResponse {
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionStepOutput output = 1
     */
    output?: AutomationExecutionStepOutput;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionRef
 */
export interface AutomationExecutionRef {
    /**
     * @generated from protobuf field: int64 id = 1
     */
    id: number;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionStepRef
 */
export interface AutomationExecutionStepRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationExecutionCountForAppRequest
 */
export interface SearchAutomationExecutionCountForAppRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.TriggerType trigger_types = 2
     */
    triggerTypes: TriggerType[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationExecutionCountForAppResponse
 */
export interface SearchAutomationExecutionCountForAppResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf enum c1.api.automations.v1.AutomationExecutionState
 */
export enum AutomationExecutionState {
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_CREATING = 2;
     */
    CREATING = 2,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_GET_STEP = 3;
     */
    GET_STEP = 3,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_PROCESS_STEP = 4;
     */
    PROCESS_STEP = 4,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_COMPLETE_STEP = 5;
     */
    COMPLETE_STEP = 5,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_DONE = 6;
     */
    DONE = 6,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_ERROR = 7;
     */
    ERROR = 7,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_TERMINATE = 8;
     */
    TERMINATE = 8,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_WAITING = 9;
     */
    WAITING = 9
}
/**
 * @generated from protobuf enum c1.api.automations.v1.AutomationExecutionStepState
 */
export enum AutomationExecutionStepState {
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STEP_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STEP_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STEP_STATE_RUNNING = 2;
     */
    RUNNING = 2,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STEP_STATE_DONE = 3;
     */
    DONE = 3,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STEP_STATE_ERROR = 4;
     */
    ERROR = 4,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STEP_STATE_CANCELLED = 5;
     */
    CANCELLED = 5,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STEP_STATE_SKIPPED = 6;
     */
    SKIPPED = 6
}
// @generated message type with reflection information, may provide speed optimized methods
class TerminateAutomationRequest$Type extends MessageType<TerminateAutomationRequest> {
    constructor() {
        super("c1.api.automations.v1.TerminateAutomationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<TerminateAutomationRequest>): TerminateAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<TerminateAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TerminateAutomationRequest): TerminateAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TerminateAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int64(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.TerminateAutomationRequest
 */
export const TerminateAutomationRequest = new TerminateAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TerminateAutomationResponse$Type extends MessageType<TerminateAutomationResponse> {
    constructor() {
        super("c1.api.automations.v1.TerminateAutomationResponse", []);
    }
    create(value?: PartialMessage<TerminateAutomationResponse>): TerminateAutomationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TerminateAutomationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TerminateAutomationResponse): TerminateAutomationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TerminateAutomationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.TerminateAutomationResponse
 */
export const TerminateAutomationResponse = new TerminateAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationExecutionsRequest$Type extends MessageType<ListAutomationExecutionsRequest> {
    constructor() {
        super("c1.api.automations.v1.ListAutomationExecutionsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ListAutomationExecutionsRequest>): ListAutomationExecutionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAutomationExecutionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAutomationExecutionsRequest): ListAutomationExecutionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAutomationExecutionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ListAutomationExecutionsRequest
 */
export const ListAutomationExecutionsRequest = new ListAutomationExecutionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationExecutionsResponse$Type extends MessageType<ListAutomationExecutionsResponse> {
    constructor() {
        super("c1.api.automations.v1.ListAutomationExecutionsResponse", [
            { no: 1, name: "automation_executions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationExecution },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAutomationExecutionsResponse>): ListAutomationExecutionsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.automationExecutions = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAutomationExecutionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAutomationExecutionsResponse): ListAutomationExecutionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.automations.v1.AutomationExecution automation_executions */ 1:
                    message.automationExecutions.push(AutomationExecution.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAutomationExecutionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.automations.v1.AutomationExecution automation_executions = 1; */
        for (let i = 0; i < message.automationExecutions.length; i++)
            AutomationExecution.internalBinaryWrite(message.automationExecutions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ListAutomationExecutionsResponse
 */
export const ListAutomationExecutionsResponse = new ListAutomationExecutionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAutomationExecutionRequest$Type extends MessageType<GetAutomationExecutionRequest> {
    constructor() {
        super("c1.api.automations.v1.GetAutomationExecutionRequest", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "expand_mask", kind: "message", T: () => AutomationExecutionExpandMask }
        ]);
    }
    create(value?: PartialMessage<GetAutomationExecutionRequest>): GetAutomationExecutionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<GetAutomationExecutionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAutomationExecutionRequest): GetAutomationExecutionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toNumber();
                    break;
                case /* c1.api.automations.v1.AutomationExecutionExpandMask expand_mask */ 2:
                    message.expandMask = AutomationExecutionExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAutomationExecutionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* c1.api.automations.v1.AutomationExecutionExpandMask expand_mask = 2; */
        if (message.expandMask)
            AutomationExecutionExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetAutomationExecutionRequest
 */
export const GetAutomationExecutionRequest = new GetAutomationExecutionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAutomationExecutionResponse$Type extends MessageType<GetAutomationExecutionResponse> {
    constructor() {
        super("c1.api.automations.v1.GetAutomationExecutionResponse", [
            { no: 1, name: "automation_execution", kind: "message", T: () => AutomationExecution },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "view", kind: "message", T: () => AutomationExecutionView }
        ]);
    }
    create(value?: PartialMessage<GetAutomationExecutionResponse>): GetAutomationExecutionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<GetAutomationExecutionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAutomationExecutionResponse): GetAutomationExecutionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.AutomationExecution automation_execution */ 1:
                    message.automationExecution = AutomationExecution.internalBinaryRead(reader, reader.uint32(), options, message.automationExecution);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.automations.v1.AutomationExecutionView view */ 3:
                    message.view = AutomationExecutionView.internalBinaryRead(reader, reader.uint32(), options, message.view);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAutomationExecutionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.AutomationExecution automation_execution = 1; */
        if (message.automationExecution)
            AutomationExecution.internalBinaryWrite(message.automationExecution, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.AutomationExecutionView view = 3; */
        if (message.view)
            AutomationExecutionView.internalBinaryWrite(message.view, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetAutomationExecutionResponse
 */
export const GetAutomationExecutionResponse = new GetAutomationExecutionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecution$Type extends MessageType<AutomationExecution> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecution", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "automation_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "state", kind: "enum", T: () => ["c1.api.automations.v1.AutomationExecutionState", AutomationExecutionState, "AUTOMATION_EXECUTION_STATE_"] },
            { no: 7, name: "context", kind: "message", T: () => AutomationContext },
            { no: 8, name: "completed_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "duration", kind: "message", T: () => Duration },
            { no: 10, name: "current_version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "is_draft", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AutomationExecution>): AutomationExecution {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.automationTemplateId = "";
        message.state = 0;
        message.currentVersion = 0;
        message.isDraft = false;
        if (value !== undefined)
            reflectionMergePartial<AutomationExecution>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutomationExecution): AutomationExecution {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toNumber();
                    break;
                case /* string automation_template_id */ 2:
                    message.automationTemplateId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* c1.api.automations.v1.AutomationExecutionState state */ 6:
                    message.state = reader.int32();
                    break;
                case /* c1.api.automations.v1.AutomationContext context */ 7:
                    message.context = AutomationContext.internalBinaryRead(reader, reader.uint32(), options, message.context);
                    break;
                case /* google.protobuf.Timestamp completed_at */ 8:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* google.protobuf.Duration duration */ 9:
                    message.duration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.duration);
                    break;
                case /* int32 current_version */ 10:
                    message.currentVersion = reader.int32();
                    break;
                case /* bool is_draft */ 11:
                    message.isDraft = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutomationExecution, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string automation_template_id = 2; */
        if (message.automationTemplateId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.automationTemplateId);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.AutomationExecutionState state = 6; */
        if (message.state !== 0)
            writer.tag(6, WireType.Varint).int32(message.state);
        /* c1.api.automations.v1.AutomationContext context = 7; */
        if (message.context)
            AutomationContext.internalBinaryWrite(message.context, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp completed_at = 8; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration duration = 9; */
        if (message.duration)
            Duration.internalBinaryWrite(message.duration, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* int32 current_version = 10; */
        if (message.currentVersion !== 0)
            writer.tag(10, WireType.Varint).int32(message.currentVersion);
        /* bool is_draft = 11; */
        if (message.isDraft !== false)
            writer.tag(11, WireType.Varint).bool(message.isDraft);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecution
 */
export const AutomationExecution = new AutomationExecution$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionExpandMask$Type extends MessageType<AutomationExecutionExpandMask> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "automation_id", "automation_trigger_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AutomationExecutionExpandMask>): AutomationExecutionExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AutomationExecutionExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutomationExecutionExpandMask): AutomationExecutionExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutomationExecutionExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionExpandMask
 */
export const AutomationExecutionExpandMask = new AutomationExecutionExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionView$Type extends MessageType<AutomationExecutionView> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionView", [
            { no: 1, name: "automation_execution", kind: "message", T: () => AutomationExecution },
            { no: 2, name: "automation_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "automation_execution_trigger_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AutomationExecutionView>): AutomationExecutionView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.automationPath = "";
        message.automationExecutionTriggerPath = "";
        if (value !== undefined)
            reflectionMergePartial<AutomationExecutionView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutomationExecutionView): AutomationExecutionView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.AutomationExecution automation_execution */ 1:
                    message.automationExecution = AutomationExecution.internalBinaryRead(reader, reader.uint32(), options, message.automationExecution);
                    break;
                case /* string automation_path */ 2:
                    message.automationPath = reader.string();
                    break;
                case /* string automation_execution_trigger_path */ 3:
                    message.automationExecutionTriggerPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutomationExecutionView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.AutomationExecution automation_execution = 1; */
        if (message.automationExecution)
            AutomationExecution.internalBinaryWrite(message.automationExecution, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string automation_path = 2; */
        if (message.automationPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.automationPath);
        /* string automation_execution_trigger_path = 3; */
        if (message.automationExecutionTriggerPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.automationExecutionTriggerPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionView
 */
export const AutomationExecutionView = new AutomationExecutionView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationExecutionsResponse$Type extends MessageType<SearchAutomationExecutionsResponse> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationExecutionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationExecutionView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchAutomationExecutionsResponse>): SearchAutomationExecutionsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAutomationExecutionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAutomationExecutionsResponse): SearchAutomationExecutionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.automations.v1.AutomationExecutionView list */ 1:
                    message.list.push(AutomationExecutionView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAutomationExecutionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.automations.v1.AutomationExecutionView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AutomationExecutionView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationExecutionsResponse
 */
export const SearchAutomationExecutionsResponse = new SearchAutomationExecutionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationExecutionsRequest$Type extends MessageType<SearchAutomationExecutionsRequest> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationExecutionsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "automation_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "expand_mask", kind: "message", T: () => AutomationExecutionExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationExecutionRef },
            { no: 7, name: "execution_step_states", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.automations.v1.AutomationExecutionState", AutomationExecutionState, "AUTOMATION_EXECUTION_STATE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 8, name: "execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAutomationExecutionsRequest>): SearchAutomationExecutionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.automationTemplateId = "";
        message.query = "";
        message.refs = [];
        message.executionStepStates = [];
        message.executionId = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchAutomationExecutionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAutomationExecutionsRequest): SearchAutomationExecutionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string automation_template_id */ 3:
                    message.automationTemplateId = reader.string();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* c1.api.automations.v1.AutomationExecutionExpandMask expand_mask */ 5:
                    message.expandMask = AutomationExecutionExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.automations.v1.AutomationExecutionRef refs */ 6:
                    message.refs.push(AutomationExecutionRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.automations.v1.AutomationExecutionState execution_step_states */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.executionStepStates.push(reader.int32());
                    else
                        message.executionStepStates.push(reader.int32());
                    break;
                case /* int64 execution_id */ 8:
                    message.executionId = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAutomationExecutionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string automation_template_id = 3; */
        if (message.automationTemplateId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.automationTemplateId);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* c1.api.automations.v1.AutomationExecutionExpandMask expand_mask = 5; */
        if (message.expandMask)
            AutomationExecutionExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.automations.v1.AutomationExecutionRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AutomationExecutionRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.automations.v1.AutomationExecutionState execution_step_states = 7; */
        if (message.executionStepStates.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.executionStepStates.length; i++)
                writer.int32(message.executionStepStates[i]);
            writer.join();
        }
        /* int64 execution_id = 8; */
        if (message.executionId !== 0)
            writer.tag(8, WireType.Varint).int64(message.executionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationExecutionsRequest
 */
export const SearchAutomationExecutionsRequest = new SearchAutomationExecutionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionTrigger$Type extends MessageType<AutomationExecutionTrigger> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionTrigger", [
            { no: 1, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 101, name: "manual", kind: "message", oneof: "kind", T: () => ManualAutomationTrigger },
            { no: 102, name: "user_profile_change", kind: "message", oneof: "kind", T: () => UserProfileChangeTrigger },
            { no: 103, name: "app_user_created", kind: "message", oneof: "kind", T: () => AppUserCreatedTrigger },
            { no: 104, name: "app_user_updated", kind: "message", oneof: "kind", T: () => AppUserUpdatedTrigger },
            { no: 105, name: "usage_based_revocation", kind: "message", oneof: "kind", T: () => UsageBasedRevocationTrigger },
            { no: 106, name: "user_created", kind: "message", oneof: "kind", T: () => UserCreatedTrigger },
            { no: 107, name: "grant_found", kind: "message", oneof: "kind", T: () => GrantFoundTrigger },
            { no: 108, name: "grant_deleted", kind: "message", oneof: "kind", T: () => GrantDeletedTrigger },
            { no: 109, name: "schedule", kind: "message", oneof: "kind", T: () => ScheduleTrigger },
            { no: 110, name: "form", kind: "message", oneof: "kind", T: () => FormTrigger },
            { no: 111, name: "schedule_app_user", kind: "message", oneof: "kind", T: () => ScheduleTriggerAppUser }
        ]);
    }
    create(value?: PartialMessage<AutomationExecutionTrigger>): AutomationExecutionTrigger {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.automationExecutionId = 0;
        message.actorId = "";
        message.kind = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AutomationExecutionTrigger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutomationExecutionTrigger): AutomationExecutionTrigger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 automation_execution_id */ 1:
                    message.automationExecutionId = reader.int64().toNumber();
                    break;
                case /* string actor_id */ 2:
                    message.actorId = reader.string();
                    break;
                case /* c1.api.automations.v1.ManualAutomationTrigger manual */ 101:
                    message.kind = {
                        oneofKind: "manual",
                        manual: ManualAutomationTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).manual)
                    };
                    break;
                case /* c1.api.automations.v1.UserProfileChangeTrigger user_profile_change */ 102:
                    message.kind = {
                        oneofKind: "userProfileChange",
                        userProfileChange: UserProfileChangeTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).userProfileChange)
                    };
                    break;
                case /* c1.api.automations.v1.AppUserCreatedTrigger app_user_created */ 103:
                    message.kind = {
                        oneofKind: "appUserCreated",
                        appUserCreated: AppUserCreatedTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).appUserCreated)
                    };
                    break;
                case /* c1.api.automations.v1.AppUserUpdatedTrigger app_user_updated */ 104:
                    message.kind = {
                        oneofKind: "appUserUpdated",
                        appUserUpdated: AppUserUpdatedTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).appUserUpdated)
                    };
                    break;
                case /* c1.api.automations.v1.UsageBasedRevocationTrigger usage_based_revocation */ 105:
                    message.kind = {
                        oneofKind: "usageBasedRevocation",
                        usageBasedRevocation: UsageBasedRevocationTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).usageBasedRevocation)
                    };
                    break;
                case /* c1.api.automations.v1.UserCreatedTrigger user_created */ 106:
                    message.kind = {
                        oneofKind: "userCreated",
                        userCreated: UserCreatedTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).userCreated)
                    };
                    break;
                case /* c1.api.automations.v1.GrantFoundTrigger grant_found */ 107:
                    message.kind = {
                        oneofKind: "grantFound",
                        grantFound: GrantFoundTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).grantFound)
                    };
                    break;
                case /* c1.api.automations.v1.GrantDeletedTrigger grant_deleted */ 108:
                    message.kind = {
                        oneofKind: "grantDeleted",
                        grantDeleted: GrantDeletedTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).grantDeleted)
                    };
                    break;
                case /* c1.api.automations.v1.ScheduleTrigger schedule */ 109:
                    message.kind = {
                        oneofKind: "schedule",
                        schedule: ScheduleTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).schedule)
                    };
                    break;
                case /* c1.api.automations.v1.FormTrigger form */ 110:
                    message.kind = {
                        oneofKind: "form",
                        form: FormTrigger.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).form)
                    };
                    break;
                case /* c1.api.automations.v1.ScheduleTriggerAppUser schedule_app_user */ 111:
                    message.kind = {
                        oneofKind: "scheduleAppUser",
                        scheduleAppUser: ScheduleTriggerAppUser.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).scheduleAppUser)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutomationExecutionTrigger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 automation_execution_id = 1; */
        if (message.automationExecutionId !== 0)
            writer.tag(1, WireType.Varint).int64(message.automationExecutionId);
        /* string actor_id = 2; */
        if (message.actorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.actorId);
        /* c1.api.automations.v1.ManualAutomationTrigger manual = 101; */
        if (message.kind.oneofKind === "manual")
            ManualAutomationTrigger.internalBinaryWrite(message.kind.manual, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.UserProfileChangeTrigger user_profile_change = 102; */
        if (message.kind.oneofKind === "userProfileChange")
            UserProfileChangeTrigger.internalBinaryWrite(message.kind.userProfileChange, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.AppUserCreatedTrigger app_user_created = 103; */
        if (message.kind.oneofKind === "appUserCreated")
            AppUserCreatedTrigger.internalBinaryWrite(message.kind.appUserCreated, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.AppUserUpdatedTrigger app_user_updated = 104; */
        if (message.kind.oneofKind === "appUserUpdated")
            AppUserUpdatedTrigger.internalBinaryWrite(message.kind.appUserUpdated, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.UsageBasedRevocationTrigger usage_based_revocation = 105; */
        if (message.kind.oneofKind === "usageBasedRevocation")
            UsageBasedRevocationTrigger.internalBinaryWrite(message.kind.usageBasedRevocation, writer.tag(105, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.UserCreatedTrigger user_created = 106; */
        if (message.kind.oneofKind === "userCreated")
            UserCreatedTrigger.internalBinaryWrite(message.kind.userCreated, writer.tag(106, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.GrantFoundTrigger grant_found = 107; */
        if (message.kind.oneofKind === "grantFound")
            GrantFoundTrigger.internalBinaryWrite(message.kind.grantFound, writer.tag(107, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.GrantDeletedTrigger grant_deleted = 108; */
        if (message.kind.oneofKind === "grantDeleted")
            GrantDeletedTrigger.internalBinaryWrite(message.kind.grantDeleted, writer.tag(108, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.ScheduleTrigger schedule = 109; */
        if (message.kind.oneofKind === "schedule")
            ScheduleTrigger.internalBinaryWrite(message.kind.schedule, writer.tag(109, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.FormTrigger form = 110; */
        if (message.kind.oneofKind === "form")
            FormTrigger.internalBinaryWrite(message.kind.form, writer.tag(110, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.ScheduleTriggerAppUser schedule_app_user = 111; */
        if (message.kind.oneofKind === "scheduleAppUser")
            ScheduleTriggerAppUser.internalBinaryWrite(message.kind.scheduleAppUser, writer.tag(111, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionTrigger
 */
export const AutomationExecutionTrigger = new AutomationExecutionTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionStep$Type extends MessageType<AutomationExecutionStep> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionStep", [
            { no: 1, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "state", kind: "enum", T: () => ["c1.api.automations.v1.AutomationExecutionStepState", AutomationExecutionStepState, "AUTOMATION_EXECUTION_STEP_STATE_"] },
            { no: 4, name: "automation_step", kind: "message", T: () => AutomationStep },
            { no: 5, name: "context", kind: "message", T: () => AutomationContext },
            { no: 6, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "output", kind: "message", T: () => AutomationExecutionStepOutput }
        ]);
    }
    create(value?: PartialMessage<AutomationExecutionStep>): AutomationExecutionStep {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.automationExecutionId = 0;
        message.id = "";
        message.state = 0;
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<AutomationExecutionStep>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutomationExecutionStep): AutomationExecutionStep {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 automation_execution_id */ 1:
                    message.automationExecutionId = reader.int64().toNumber();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* c1.api.automations.v1.AutomationExecutionStepState state */ 3:
                    message.state = reader.int32();
                    break;
                case /* c1.api.automations.v1.AutomationStep automation_step */ 4:
                    message.automationStep = AutomationStep.internalBinaryRead(reader, reader.uint32(), options, message.automationStep);
                    break;
                case /* c1.api.automations.v1.AutomationContext context */ 5:
                    message.context = AutomationContext.internalBinaryRead(reader, reader.uint32(), options, message.context);
                    break;
                case /* string error_message */ 6:
                    message.errorMessage = reader.string();
                    break;
                case /* c1.api.automations.v1.AutomationExecutionStepOutput output */ 7:
                    message.output = AutomationExecutionStepOutput.internalBinaryRead(reader, reader.uint32(), options, message.output);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutomationExecutionStep, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 automation_execution_id = 1; */
        if (message.automationExecutionId !== 0)
            writer.tag(1, WireType.Varint).int64(message.automationExecutionId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* c1.api.automations.v1.AutomationExecutionStepState state = 3; */
        if (message.state !== 0)
            writer.tag(3, WireType.Varint).int32(message.state);
        /* c1.api.automations.v1.AutomationStep automation_step = 4; */
        if (message.automationStep)
            AutomationStep.internalBinaryWrite(message.automationStep, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.AutomationContext context = 5; */
        if (message.context)
            AutomationContext.internalBinaryWrite(message.context, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string error_message = 6; */
        if (message.errorMessage !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.errorMessage);
        /* c1.api.automations.v1.AutomationExecutionStepOutput output = 7; */
        if (message.output)
            AutomationExecutionStepOutput.internalBinaryWrite(message.output, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionStep
 */
export const AutomationExecutionStep = new AutomationExecutionStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionStepOutput$Type extends MessageType<AutomationExecutionStepOutput> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionStepOutput", [
            { no: 1, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "automation_execution_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 101, name: "success", kind: "message", oneof: "kind", T: () => AutomationExecutionStepOutputSuccess },
            { no: 102, name: "error", kind: "message", oneof: "kind", T: () => AutomationExecutionStepOutputError }
        ]);
    }
    create(value?: PartialMessage<AutomationExecutionStepOutput>): AutomationExecutionStepOutput {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.automationExecutionId = 0;
        message.automationExecutionStepId = "";
        message.id = "";
        message.kind = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AutomationExecutionStepOutput>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutomationExecutionStepOutput): AutomationExecutionStepOutput {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 automation_execution_id */ 1:
                    message.automationExecutionId = reader.int64().toNumber();
                    break;
                case /* string automation_execution_step_id */ 2:
                    message.automationExecutionStepId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                case /* c1.api.automations.v1.AutomationExecutionStepOutputSuccess success */ 101:
                    message.kind = {
                        oneofKind: "success",
                        success: AutomationExecutionStepOutputSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).success)
                    };
                    break;
                case /* c1.api.automations.v1.AutomationExecutionStepOutputError error */ 102:
                    message.kind = {
                        oneofKind: "error",
                        error: AutomationExecutionStepOutputError.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutomationExecutionStepOutput, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 automation_execution_id = 1; */
        if (message.automationExecutionId !== 0)
            writer.tag(1, WireType.Varint).int64(message.automationExecutionId);
        /* string automation_execution_step_id = 2; */
        if (message.automationExecutionStepId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.automationExecutionStepId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        /* c1.api.automations.v1.AutomationExecutionStepOutputSuccess success = 101; */
        if (message.kind.oneofKind === "success")
            AutomationExecutionStepOutputSuccess.internalBinaryWrite(message.kind.success, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.automations.v1.AutomationExecutionStepOutputError error = 102; */
        if (message.kind.oneofKind === "error")
            AutomationExecutionStepOutputError.internalBinaryWrite(message.kind.error, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionStepOutput
 */
export const AutomationExecutionStepOutput = new AutomationExecutionStepOutput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionStepOutputSuccess$Type extends MessageType<AutomationExecutionStepOutputSuccess> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionStepOutputSuccess", [
            { no: 1, name: "exported_context", kind: "message", T: () => AutomationContext }
        ]);
    }
    create(value?: PartialMessage<AutomationExecutionStepOutputSuccess>): AutomationExecutionStepOutputSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AutomationExecutionStepOutputSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutomationExecutionStepOutputSuccess): AutomationExecutionStepOutputSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.AutomationContext exported_context */ 1:
                    message.exportedContext = AutomationContext.internalBinaryRead(reader, reader.uint32(), options, message.exportedContext);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutomationExecutionStepOutputSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.AutomationContext exported_context = 1; */
        if (message.exportedContext)
            AutomationContext.internalBinaryWrite(message.exportedContext, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionStepOutputSuccess
 */
export const AutomationExecutionStepOutputSuccess = new AutomationExecutionStepOutputSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionStepOutputError$Type extends MessageType<AutomationExecutionStepOutputError> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionStepOutputError", [
            { no: 1, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AutomationExecutionStepOutputError>): AutomationExecutionStepOutputError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<AutomationExecutionStepOutputError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutomationExecutionStepOutputError): AutomationExecutionStepOutputError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string error */ 1:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutomationExecutionStepOutputError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string error = 1; */
        if (message.error !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionStepOutputError
 */
export const AutomationExecutionStepOutputError = new AutomationExecutionStepOutputError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CompletedAutomationExecutionStep$Type extends MessageType<CompletedAutomationExecutionStep> {
    constructor() {
        super("c1.api.automations.v1.CompletedAutomationExecutionStep", [
            { no: 1, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "state", kind: "enum", T: () => ["c1.api.automations.v1.AutomationExecutionStepState", AutomationExecutionStepState, "AUTOMATION_EXECUTION_STEP_STATE_"] },
            { no: 4, name: "step", kind: "message", T: () => AutomationExecutionStep }
        ]);
    }
    create(value?: PartialMessage<CompletedAutomationExecutionStep>): CompletedAutomationExecutionStep {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.automationExecutionId = 0;
        message.id = "";
        message.state = 0;
        if (value !== undefined)
            reflectionMergePartial<CompletedAutomationExecutionStep>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CompletedAutomationExecutionStep): CompletedAutomationExecutionStep {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 automation_execution_id */ 1:
                    message.automationExecutionId = reader.int64().toNumber();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* c1.api.automations.v1.AutomationExecutionStepState state */ 3:
                    message.state = reader.int32();
                    break;
                case /* c1.api.automations.v1.AutomationExecutionStep step */ 4:
                    message.step = AutomationExecutionStep.internalBinaryRead(reader, reader.uint32(), options, message.step);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CompletedAutomationExecutionStep, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 automation_execution_id = 1; */
        if (message.automationExecutionId !== 0)
            writer.tag(1, WireType.Varint).int64(message.automationExecutionId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* c1.api.automations.v1.AutomationExecutionStepState state = 3; */
        if (message.state !== 0)
            writer.tag(3, WireType.Varint).int32(message.state);
        /* c1.api.automations.v1.AutomationExecutionStep step = 4; */
        if (message.step)
            AutomationExecutionStep.internalBinaryWrite(message.step, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CompletedAutomationExecutionStep
 */
export const CompletedAutomationExecutionStep = new CompletedAutomationExecutionStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCompletedAutomationExecutionStepRequest$Type extends MessageType<GetCompletedAutomationExecutionStepRequest> {
    constructor() {
        super("c1.api.automations.v1.GetCompletedAutomationExecutionStepRequest", [
            { no: 1, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "validate.rules": { int64: { gt: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<GetCompletedAutomationExecutionStepRequest>): GetCompletedAutomationExecutionStepRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.automationExecutionId = 0;
        if (value !== undefined)
            reflectionMergePartial<GetCompletedAutomationExecutionStepRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCompletedAutomationExecutionStepRequest): GetCompletedAutomationExecutionStepRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 automation_execution_id */ 1:
                    message.automationExecutionId = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCompletedAutomationExecutionStepRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 automation_execution_id = 1; */
        if (message.automationExecutionId !== 0)
            writer.tag(1, WireType.Varint).int64(message.automationExecutionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetCompletedAutomationExecutionStepRequest
 */
export const GetCompletedAutomationExecutionStepRequest = new GetCompletedAutomationExecutionStepRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCompletedAutomationExecutionStepResponse$Type extends MessageType<GetCompletedAutomationExecutionStepResponse> {
    constructor() {
        super("c1.api.automations.v1.GetCompletedAutomationExecutionStepResponse", [
            { no: 1, name: "completed_automation_execution_steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CompletedAutomationExecutionStep }
        ]);
    }
    create(value?: PartialMessage<GetCompletedAutomationExecutionStepResponse>): GetCompletedAutomationExecutionStepResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.completedAutomationExecutionSteps = [];
        if (value !== undefined)
            reflectionMergePartial<GetCompletedAutomationExecutionStepResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCompletedAutomationExecutionStepResponse): GetCompletedAutomationExecutionStepResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.automations.v1.CompletedAutomationExecutionStep completed_automation_execution_steps */ 1:
                    message.completedAutomationExecutionSteps.push(CompletedAutomationExecutionStep.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCompletedAutomationExecutionStepResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.automations.v1.CompletedAutomationExecutionStep completed_automation_execution_steps = 1; */
        for (let i = 0; i < message.completedAutomationExecutionSteps.length; i++)
            CompletedAutomationExecutionStep.internalBinaryWrite(message.completedAutomationExecutionSteps[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetCompletedAutomationExecutionStepResponse
 */
export const GetCompletedAutomationExecutionStepResponse = new GetCompletedAutomationExecutionStepResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationExecutionStepsRequest$Type extends MessageType<ListAutomationExecutionStepsRequest> {
    constructor() {
        super("c1.api.automations.v1.ListAutomationExecutionStepsRequest", [
            { no: 1, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "validate.rules": { int64: { gt: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<ListAutomationExecutionStepsRequest>): ListAutomationExecutionStepsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.automationExecutionId = 0;
        if (value !== undefined)
            reflectionMergePartial<ListAutomationExecutionStepsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAutomationExecutionStepsRequest): ListAutomationExecutionStepsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 automation_execution_id */ 1:
                    message.automationExecutionId = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAutomationExecutionStepsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 automation_execution_id = 1; */
        if (message.automationExecutionId !== 0)
            writer.tag(1, WireType.Varint).int64(message.automationExecutionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ListAutomationExecutionStepsRequest
 */
export const ListAutomationExecutionStepsRequest = new ListAutomationExecutionStepsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationExecutionStepsResponse$Type extends MessageType<ListAutomationExecutionStepsResponse> {
    constructor() {
        super("c1.api.automations.v1.ListAutomationExecutionStepsResponse", [
            { no: 1, name: "automation_execution_steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationExecutionStep }
        ]);
    }
    create(value?: PartialMessage<ListAutomationExecutionStepsResponse>): ListAutomationExecutionStepsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.automationExecutionSteps = [];
        if (value !== undefined)
            reflectionMergePartial<ListAutomationExecutionStepsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAutomationExecutionStepsResponse): ListAutomationExecutionStepsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.automations.v1.AutomationExecutionStep automation_execution_steps */ 1:
                    message.automationExecutionSteps.push(AutomationExecutionStep.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAutomationExecutionStepsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.automations.v1.AutomationExecutionStep automation_execution_steps = 1; */
        for (let i = 0; i < message.automationExecutionSteps.length; i++)
            AutomationExecutionStep.internalBinaryWrite(message.automationExecutionSteps[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ListAutomationExecutionStepsResponse
 */
export const ListAutomationExecutionStepsResponse = new ListAutomationExecutionStepsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationExecutionStepsRequest$Type extends MessageType<SearchAutomationExecutionStepsRequest> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationExecutionStepsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationExecutionStepRef }
        ]);
    }
    create(value?: PartialMessage<SearchAutomationExecutionStepsRequest>): SearchAutomationExecutionStepsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.automationExecutionId = 0;
        message.query = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAutomationExecutionStepsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAutomationExecutionStepsRequest): SearchAutomationExecutionStepsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* int64 automation_execution_id */ 3:
                    message.automationExecutionId = reader.int64().toNumber();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.automations.v1.AutomationExecutionStepRef refs */ 5:
                    message.refs.push(AutomationExecutionStepRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAutomationExecutionStepsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* int64 automation_execution_id = 3; */
        if (message.automationExecutionId !== 0)
            writer.tag(3, WireType.Varint).int64(message.automationExecutionId);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.automations.v1.AutomationExecutionStepRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            AutomationExecutionStepRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationExecutionStepsRequest
 */
export const SearchAutomationExecutionStepsRequest = new SearchAutomationExecutionStepsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationExecutionStepsResponse$Type extends MessageType<SearchAutomationExecutionStepsResponse> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationExecutionStepsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationExecutionStep },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAutomationExecutionStepsResponse>): SearchAutomationExecutionStepsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAutomationExecutionStepsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAutomationExecutionStepsResponse): SearchAutomationExecutionStepsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.automations.v1.AutomationExecutionStep list */ 1:
                    message.list.push(AutomationExecutionStep.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAutomationExecutionStepsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.automations.v1.AutomationExecutionStep list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AutomationExecutionStep.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationExecutionStepsResponse
 */
export const SearchAutomationExecutionStepsResponse = new SearchAutomationExecutionStepsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAutomationExecutionStepOutputRequest$Type extends MessageType<GetAutomationExecutionStepOutputRequest> {
    constructor() {
        super("c1.api.automations.v1.GetAutomationExecutionStepOutputRequest", [
            { no: 1, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "validate.rules": { int64: { gt: "0" } } } },
            { no: 2, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<GetAutomationExecutionStepOutputRequest>): GetAutomationExecutionStepOutputRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.automationExecutionId = 0;
        message.stepId = "";
        if (value !== undefined)
            reflectionMergePartial<GetAutomationExecutionStepOutputRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAutomationExecutionStepOutputRequest): GetAutomationExecutionStepOutputRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 automation_execution_id */ 1:
                    message.automationExecutionId = reader.int64().toNumber();
                    break;
                case /* string step_id */ 2:
                    message.stepId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAutomationExecutionStepOutputRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 automation_execution_id = 1; */
        if (message.automationExecutionId !== 0)
            writer.tag(1, WireType.Varint).int64(message.automationExecutionId);
        /* string step_id = 2; */
        if (message.stepId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.stepId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetAutomationExecutionStepOutputRequest
 */
export const GetAutomationExecutionStepOutputRequest = new GetAutomationExecutionStepOutputRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAutomationExecutionStepOutputResponse$Type extends MessageType<GetAutomationExecutionStepOutputResponse> {
    constructor() {
        super("c1.api.automations.v1.GetAutomationExecutionStepOutputResponse", [
            { no: 1, name: "output", kind: "message", T: () => AutomationExecutionStepOutput }
        ]);
    }
    create(value?: PartialMessage<GetAutomationExecutionStepOutputResponse>): GetAutomationExecutionStepOutputResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAutomationExecutionStepOutputResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAutomationExecutionStepOutputResponse): GetAutomationExecutionStepOutputResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.AutomationExecutionStepOutput output */ 1:
                    message.output = AutomationExecutionStepOutput.internalBinaryRead(reader, reader.uint32(), options, message.output);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAutomationExecutionStepOutputResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.AutomationExecutionStepOutput output = 1; */
        if (message.output)
            AutomationExecutionStepOutput.internalBinaryWrite(message.output, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetAutomationExecutionStepOutputResponse
 */
export const GetAutomationExecutionStepOutputResponse = new GetAutomationExecutionStepOutputResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionRef$Type extends MessageType<AutomationExecutionRef> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionRef", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "validate.rules": { int64: { gte: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<AutomationExecutionRef>): AutomationExecutionRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<AutomationExecutionRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutomationExecutionRef): AutomationExecutionRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutomationExecutionRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int64(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionRef
 */
export const AutomationExecutionRef = new AutomationExecutionRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionStepRef$Type extends MessageType<AutomationExecutionStepRef> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionStepRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<AutomationExecutionStepRef>): AutomationExecutionStepRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AutomationExecutionStepRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutomationExecutionStepRef): AutomationExecutionStepRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutomationExecutionStepRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionStepRef
 */
export const AutomationExecutionStepRef = new AutomationExecutionStepRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationExecutionCountForAppRequest$Type extends MessageType<SearchAutomationExecutionCountForAppRequest> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationExecutionCountForAppRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "trigger_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.automations.v1.TriggerType", TriggerType, "TRIGGER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAutomationExecutionCountForAppRequest>): SearchAutomationExecutionCountForAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.triggerTypes = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAutomationExecutionCountForAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAutomationExecutionCountForAppRequest): SearchAutomationExecutionCountForAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* repeated c1.api.automations.v1.TriggerType trigger_types */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.triggerTypes.push(reader.int32());
                    else
                        message.triggerTypes.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAutomationExecutionCountForAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* repeated c1.api.automations.v1.TriggerType trigger_types = 2; */
        if (message.triggerTypes.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.triggerTypes.length; i++)
                writer.int32(message.triggerTypes[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationExecutionCountForAppRequest
 */
export const SearchAutomationExecutionCountForAppRequest = new SearchAutomationExecutionCountForAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationExecutionCountForAppResponse$Type extends MessageType<SearchAutomationExecutionCountForAppResponse> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationExecutionCountForAppResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAutomationExecutionCountForAppResponse>): SearchAutomationExecutionCountForAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchAutomationExecutionCountForAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAutomationExecutionCountForAppResponse): SearchAutomationExecutionCountForAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAutomationExecutionCountForAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationExecutionCountForAppResponse
 */
export const SearchAutomationExecutionCountForAppResponse = new SearchAutomationExecutionCountForAppResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.automations.v1.AutomationExecutionSearchService
 */
export const AutomationExecutionSearchService = new ServiceType("c1.api.automations.v1.AutomationExecutionSearchService", [
    { name: "SearchAutomationExecutions", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/automation_executions", group: "Automations" }] } }, I: SearchAutomationExecutionsRequest, O: SearchAutomationExecutionsResponse },
    { name: "SearchAutomationExecutionCountForApp", options: { "authz.method": { role: "VIEWER" } }, I: SearchAutomationExecutionCountForAppRequest, O: SearchAutomationExecutionCountForAppResponse },
    { name: "SearchAutomationExecutionSteps", options: { "authz.method": { role: "VIEWER" } }, I: SearchAutomationExecutionStepsRequest, O: SearchAutomationExecutionStepsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.automations.v1.AutomationExecutionService
 */
export const AutomationExecutionService = new ServiceType("c1.api.automations.v1.AutomationExecutionService", [
    { name: "GetAutomationExecution", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/automation_executions/{id}", group: "Automations" }] } }, I: GetAutomationExecutionRequest, O: GetAutomationExecutionResponse },
    { name: "ListAutomationExecutions", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/automation_executions", group: "Automations" }] } }, I: ListAutomationExecutionsRequest, O: ListAutomationExecutionsResponse },
    { name: "ListAutomationExecutionSteps", options: { "authz.method": { role: "VIEWER" } }, I: ListAutomationExecutionStepsRequest, O: ListAutomationExecutionStepsResponse },
    { name: "GetAutomationExecutionStepOutput", options: { "authz.method": { role: "VIEWER" } }, I: GetAutomationExecutionStepOutputRequest, O: GetAutomationExecutionStepOutputResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.automations.v1.AutomationExecutionActionsService
 */
export const AutomationExecutionActionsService = new ServiceType("c1.api.automations.v1.AutomationExecutionActionsService", [
    { name: "TerminateAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/automation_executions/{id}/actions/terminate", group: "Automations" }] } }, I: TerminateAutomationRequest, O: TerminateAutomationResponse }
]);
